import { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes

// Create the context
const AppContext = createContext();

// Custom hook for using the context easily
export const useAppContext = () => {
  return useContext(AppContext);
};

// Provider to wrap your app
const AppProvider = ({ children }) => {
  const [events, setEvents] = useState([]);

  const addEvent = (event) => {
    setEvents((prevEvents) => [...prevEvents, event]);
  };

  const removeEvent = (index) => {
    setEvents((prevEvents) => prevEvents.filter((_, i) => i !== index));
  };

  useEffect(() => {
    const handleOnline = () => {
      addEvent({ type: 'success', message: "You're back online!" });
    };

    const handleOffline = () => {
      addEvent({ type: 'warning', message: 'You are offline. Some features may not be available.' });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <AppContext.Provider value={{ events, addEvent, removeEvent }}>
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired, // PropTypes for the children prop, which is required
};

export default AppProvider;
